import { render } from "./P060.vue?vue&type=template&id=36973c56&scoped=true"
import script from "./P060.vue?vue&type=script&lang=js"
export * from "./P060.vue?vue&type=script&lang=js"

import "./P060.vue?vue&type=style&index=0&id=36973c56&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36973c56"]])

export default __exports__